import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'Locales';
import { TextField } from 'Components';
import { ColumnView, RowView } from 'Containers';
import { FormattedLabel, ibanMaskConfig } from 'Helpers';

import { getFieldProp, getIconColor } from '../../../shared';

class BankAccountFR extends Component {
  constructor(props) {
    super(props);
    this.registrationNumberProp = getFieldProp(this.props.fields, 'registrationNumber');
    this.bankNameProp = getFieldProp(this.props.fields, 'bankName');
    this.bicProp = getFieldProp(this.props.fields, 'bic');
  }

  componentDidUpdate = prevProps => {
    const { forceUpdate, updateValue, value: bankAccountValues } = this.props;
    if (forceUpdate !== prevProps.forceUpdate) {
      if (bankAccountValues.registrationNumber?.length > 0) {
        updateValue({
          value: {
            registrationNumber: bankAccountValues.registrationNumber,
            bic: '',
            bankName: '',
            validationStatus: '',
            validationMessage: ''
          },
          updatingKey: 'registrationNumber'
        });
      }
    }
  };

  render = () => {
    const { bankNameProp, bicProp, props, registrationNumberProp } = this;
    const { required, shouldShowError, updateValue, value } = props;

    let bankAccountValues = value;
    if (!bankAccountValues) {
      bankAccountValues = {
        bankName: '',
        bic: '',
        registrationNumber: ''
      };
    }

    const { bankName, bic, registrationNumber } = bankAccountValues;

    return (
      <ColumnView>
        <RowView>
          <TextField
            label={FormattedLabel({ required, name: I18n.t('flow:components.bankAccount.registrationNumber') })}
            type={'text'}
            placeholder={registrationNumberProp?.placeholder}
            className={'flex1'}
            value={ibanMaskConfig(registrationNumber)}
            onChange={e =>
              updateValue({
                value: {
                  registrationNumber: e.target.value,
                  bic: '',
                  bankName: '',
                  validationStatus: '',
                  validationMessage: ''
                },
                updatingKey: 'registrationNumber'
              })
            }
            onBlur={() =>
              updateValue({
                value: {
                  registrationNumber: bankAccountValues.registrationNumber,
                  bic: '',
                  bankName: '',
                  validationStatus: '',
                  validationMessage: ''
                },
                updatingKey: 'registrationNumber'
              })
            }
            validateOnBlur={true}
            errorMessageForce={shouldShowError}
            errorMessage={I18n.t('flow:generalError')}
            icon="material:check"
            iconColor={getIconColor(shouldShowError, registrationNumber)}
          />
        </RowView>

        {bankName && (
          <RowView>
            <TextField
              label={FormattedLabel({ required, name: I18n.t('flow:components.bankAccount.bankName') })}
              type={'text'}
              placeholder={bankNameProp?.placeholder}
              className={'flex1'}
              value={bankName}
              disabled
              icon="material:check"
              iconColor={getIconColor(false, bankName)}
            />
          </RowView>
        )}
        {bic && (
          <RowView>
            <TextField
              label={FormattedLabel({ required, name: I18n.t('flow:components.bankAccount.bic') })}
              type={'text'}
              placeholder={bicProp?.placeholder}
              className={'flex1'}
              value={bic}
              disabled
              icon="material:check"
              iconColor={getIconColor(false, bic)}
            />
          </RowView>
        )}
      </ColumnView>
    );
  };
}

BankAccountFR.propTypes = {
  fields: PropTypes.array,
  forceUpdate: PropTypes.number,
  required: PropTypes.bool,
  shouldShowError: PropTypes.bool,
  updateValue: PropTypes.func,
  value: PropTypes.any
};

export default BankAccountFR;
